webpackJsonp([2],{

/***/ "4gQz":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "4vlF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('v-app',{attrs:{"slot":"activator","toolbar":""},slot:"activator"},[_c('v-navigation-drawer',{staticClass:"blue-grey darken-2",staticStyle:{"position":"fixed"},attrs:{"absolute":"","persistent":"","light":"","overflow":""},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-toolbar',{staticClass:"transparent",attrs:{"flat":"","id":"sidebar-menu"}},[_c('v-list',{staticClass:"pa-0 transparent"},[_c('v-list-tile',{staticClass:"mt-4",attrs:{"avatar":""}},[_c('v-list-tile-avatar',[(!_vm.user)?_c('img',{attrs:{"src":__webpack_require__("4gQz")}}):_vm._e(),_vm._v(" "),(_vm.user)?_c('img',{attrs:{"src":_vm.user.photoURL}}):_vm._e()]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"grey--text text--lighten-2"},[(_vm.user)?_c('v-list-tile-title',[_vm._v(_vm._s(_vm.user.displayName))]):_vm._e(),_vm._v(" "),(!_vm.user)?_c('v-list-tile-title',[_vm._v("Bitte anmelden")]):_vm._e(),_vm._v(" "),(_vm.myHcp)?_c('v-list-tile-sub-title',{staticClass:"grey--text text--lighten-2"},[_vm._v("Handycap "+_vm._s(_vm.myHcp))]):_vm._e(),_vm._v(" "),(!_vm.myHcp && _vm.user)?_c('v-list-tile-sub-title',{staticClass:"grey--text text--lighten-2"},[_vm._v("Bitte Handycap eingeben")]):_vm._e()],1)],1),_vm._v(" "),(!_vm.user)?_c('v-btn',{staticClass:"right mt-3 mr-3 warning",on:{"click":_vm.login}},[_vm._v("Anmelden")]):_vm._e(),_vm._v(" "),(_vm.user)?_c('v-btn',{staticClass:"right mt-3 mr-3 warning",on:{"click":_vm.logout}},[_vm._v("Abmelden")]):_vm._e()],1)],1),_vm._v(" "),(_vm.user)?_c('div',[(_vm.myHcp)?_c('v-list',{staticClass:"pt-0 transparent"},[_c('v-divider'),_vm._v(" "),_c('v-list-tile',{attrs:{"to":'/'},on:{"click":_vm.getActualRound}},[_c('v-list-tile-action',[_c('v-icon',{staticClass:"grey--text text--lighten-2"},[_vm._v("mode_edit")])],1),_vm._v(" "),_c('v-list-tile-content',{staticClass:"grey--text text--lighten-2"},[_c('v-list-tile-title',[_vm._v("Aktuelle Runde")])],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"to":'/LetzteRunden'},on:{"click":_vm.getLastRounds}},[_c('v-list-tile-action',[_c('v-icon',{staticClass:"grey--text text--lighten-2"},[_vm._v("replay_5")])],1),_vm._v(" "),_c('v-list-tile-content',{staticClass:"grey--text text--lighten-2"},[_c('v-list-tile-title',[_vm._v("Letzte 5 Runden")])],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"to":'/SucheRunde'},on:{"click":_vm.x}},[_c('v-list-tile-action',[_c('v-icon',{staticClass:"grey--text text--lighten-2"},[_vm._v("search")])],1),_vm._v(" "),_c('v-list-tile-content',{staticClass:"grey--text text--lighten-2"},[_c('v-list-tile-title',[_vm._v("Suche Runde")])],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-divider',{staticClass:"grey lighten-1"}),_vm._v(" "),_c('v-list',{staticClass:"pt-0 transparent"},[_c('v-list-tile',{on:{"click":function($event){$event.stopPropagation();_vm.openDialog($event)}}},[_c('v-list-tile-action',[_c('v-icon',{staticClass:"grey--text text--lighten-2"},[_vm._v("settings")])],1),_vm._v(" "),_c('v-list-tile-content',{staticClass:"grey--text text--lighten-2"},[_c('v-list-tile-title',[_vm._v("Handycap eingeben")])],1)],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"grey lighten-1"}),_vm._v(" "),(_vm.myHcp)?_c('v-list',{staticClass:"pt-0 transparent"},[_c('v-list-tile',{attrs:{"to":'/'},on:{"click":_vm.newRoundYellow}},[_c('v-list-tile-action',[_c('v-icon',{staticClass:"yellow--text"},[_vm._v("golf_course")])],1),_vm._v(" "),_c('v-list-tile-content',{staticClass:"yellow--text"},[_c('v-list-tile-title',[_vm._v("Neue Runde")])],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"to":'/'},on:{"click":_vm.x}},[_c('v-list-tile-action',[_c('v-icon',{staticClass:"white--text"},[_vm._v("golf_course")])],1),_vm._v(" "),_c('v-list-tile-content',{staticClass:"white--text"},[_c('v-list-tile-title',[_vm._v("Neue Runde")])],1)],1)],1):_vm._e()],1):_vm._e()],1),_vm._v(" "),_c('v-toolbar',{staticClass:"blue-grey darken-2",attrs:{"fixed":"","dark":""}},[_c('v-toolbar-side-icon',{on:{"click":function($event){$event.stopPropagation();_vm.drawer = !_vm.drawer}}}),_vm._v(" "),_c('v-toolbar-title',[_vm._v("MyGolfApp")])],1),_vm._v(" "),_c('main',[_c('v-container',{attrs:{"fluid":"","id":"main"}},[_c('router-view')],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"lazy":"","absolute":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',[_c('div',{staticClass:"headline"},[_vm._v("Handycap eingeben")])]),_vm._v(" "),_c('v-card-text',[_c('p',[_vm._v("Bitte geben Sie Ihr Handycap ein,"),_c('br'),_vm._v("z.B. -12,4")]),_vm._v(" "),(_vm.myHcp != null)?_c('p',[_c('strong',[_vm._v("Aktuelles Handycap "+_vm._s(_vm.myHcp))])]):_vm._e(),_vm._v(" "),_c('v-form',[_c('v-text-field',{attrs:{"label":"Handycap","type":"number"},model:{value:(_vm.number),callback:function ($$v) {_vm.number=$$v},expression:"number"}})],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"red--text darken-1",attrs:{"flat":"flat"},nativeOn:{"click":function($event){_vm.dialog = false}}},[_vm._v("Abbrechen")]),_vm._v(" "),_c('v-btn',{staticClass:"blue--text darken-1",attrs:{"flat":"flat"},nativeOn:{"click":function($event){_vm.setHcp($event)}}},[_vm._v("Speichern")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6He6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "AktuelleRunde",
  data: function data() {
    return {
      yellowArray: [5, 4, 4, 4, 4, 3, 4, 4, 4, 4, 3, 4, 4, 4, 5, 3, 5, 5],
      stablefordYellow: [11, 15, 3, 1, 9, 13, 7, 5, 17, 10, 12, 16, 2, 4, 8, 18, 14, 6],
      dialog: false,
      options: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
      number: "0",
      hole: null
    };
    // End Data
  },


  computed: {
    user: function user() {
      return this.$store.getters.user;
    },
    myHcp: function myHcp() {
      return this.$store.getters.myHcp;
    },
    year: function year() {
      return this.$store.getters.year;
    },
    key: function key() {
      return this.$store.getters.actualRoundKey;
    },
    loading: function loading() {
      return this.$store.getters.loading;
    },
    round: function round() {
      return this.$store.getters.actualRound;
    },
    myColorArray: function myColorArray() {
      if (this.round.val().farbe == "gelb") {
        return this.yellowArray;
      }
    },
    myStablefordYellow: function myStablefordYellow() {
      if (this.myHcp !== null && this.myHcp !== undefined) {
        var myStablefordCalc = this.myHcp * (130 / 113) - 73.1 + 73;
        var myStablefordRound = Math.round(myStablefordCalc);
        var spielvorgabe = Math.abs(myStablefordRound);
        var divident = spielvorgabe / 18;
        var yellowArray = [];
        // Hcp < 18
        if (divident <= 1) {
          for (var i = 0; i < 18; i++) {
            var q = this.stablefordYellow[i];
            if (q <= spielvorgabe) {
              yellowArray.push(1);
            } else {
              yellowArray.push(0);
            }
          }
        } else if (divident > 1 && divident <= 2) {
          // Hcp > 18 und <= 36
          for (var i = 0; i < 18; i++) {
            var q = this.stablefordYellow[i];
            if (q > spielvorgabe - 18) {
              yellowArray.push(1);
            } else {
              yellowArray.push(2);
            }
          }
        }
        return yellowArray;
      }
    },
    myStablefordYellowSign: function myStablefordYellowSign() {
      if (this.myHcp !== null && this.myHcp !== undefined) {
        var myStablefordCalc = this.myHcp * (130 / 113) - 73.1 + 73;
        var myStablefordRound = Math.round(myStablefordCalc);
        var spielvorgabe = Math.abs(myStablefordRound);
        var divident = spielvorgabe / 18;
        var yellowSignArray = [];
        // Hcp < 18
        if (divident <= 1) {
          for (var i = 0; i < 18; i++) {
            var q = this.stablefordYellow[i];
            if (q <= spielvorgabe) {
              yellowSignArray.push("/");
            } else {
              yellowSignArray.push("");
            }
          }
        } else if (divident > 1 && divident <= 2) {
          // Hcp > 18 und <= 36
          for (var i = 0; i < 18; i++) {
            var q = this.stablefordYellow[i];
            if (q > spielvorgabe - 18) {
              yellowSignArray.push("/");
            } else {
              yellowSignArray.push("//");
            }
          }
        }
        return yellowSignArray;
      }
    },
    scoreOut: function scoreOut() {
      if (this.round !== null) {
        var score = 0;
        var x = this.round.val();
        score = x.score1 + x.score2 + x.score3 + x.score4 + x.score5 + x.score6 + x.score7 + x.score8 + x.score9;
      }
      return score;
    },
    scoreIn: function scoreIn() {
      if (this.round !== null) {
        var score = 0;
        var x = this.round.val();
        score = x.score10 + x.score11 + x.score12 + x.score13 + x.score14 + x.score15 + x.score16 + x.score17 + x.score18;
      }
      return score;
    },
    score: function score() {
      if (this.round !== null) {
        return this.scoreIn + this.scoreOut;
      }
    },
    pointsOut: function pointsOut() {
      if (this.round !== null) {
        var pointsOut = [];
        var obj = this.round.val();
        for (var i = 1; i < 19; i++) {
          var x = "score" + i;
          if (obj[x] == 0) {
            pointsOut.push(0);
          } else {
            var pointOut = this.myColorArray[i - 1] + this.myStablefordYellow[i - 1] - obj[x];
            if (pointOut == 0) {
              pointsOut.push(2);
            } else if (pointOut == 1) {
              pointsOut.push(3);
            } else if (pointOut >= 2) {
              pointsOut.push(4);
            } else if (pointOut == -1) {
              pointsOut.push(1);
            } else {
              pointsOut.push(0);
            }
          }
        }
        return pointsOut;
      }
    },
    sumPointsOut: function sumPointsOut() {
      if (this.round !== null) {
        var sum = 0;
        for (var i = 0; i < 9; i++) {
          sum = sum + this.pointsOut[i];
        }
        return sum;
      }
    },
    sumPointsIn: function sumPointsIn() {
      if (this.round !== null) {
        var sum = 0;
        for (var i = 8; i < 18; i++) {
          sum = sum + this.pointsOut[i];
        }
        return sum;
      }
    },
    points: function points() {
      if (this.round !== null) {
        return this.sumPointsOut + this.sumPointsIn;
      }
    }

    // End Computed

  },

  watch: {
    points: function points() {
      this.updateShortround();
    }
  },

  methods: {
    setScore: function setScore() {
      if (this.number != null) {
        this.$store.dispatch("editScore", {
          key: this.key,
          loch: "score" + this.hole,
          score: Number(this.number),
          shortKey: this.round.val().shortKey,
          sumScore: this.score,
          points: this.points
        });
        this.dialog = false;
        this.number = "0";
      }
    },
    updateShortround: function updateShortround() {
      if (this.number != null) {
        this.$store.dispatch("updateShortround", {
          shortKey: this.round.val().shortKey,
          score: this.score,
          points: this.points
        });
      }
    }
    // End Methods

  }
});

/***/ }),

/***/ "ATWO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CB0t":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase__ = __webpack_require__("q6Ae");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
	state: {
		user: null,
		loading: false,
		error: null,
		year: null,
		myHcp: null,
		actualRoundKey: null,
		actualRound: null,
		lastFiveRounds: null,
		searchRounds: null
	},

	mutations: {
		setUser: function setUser(state, payload) {
			state.user = payload;
		},
		setLoading: function setLoading(state, payload) {
			state.loading = payload;
		},
		setError: function setError(state, payload) {
			state.error = payload;
		},
		clearError: function clearError(state) {
			state.error = null;
		},
		setYear: function setYear(state, payload) {
			state.year = payload;
		},
		myHcp: function myHcp(state, payload) {
			state.myHcp = payload;
		},
		actualRoundKey: function actualRoundKey(state, payload) {
			state.actualRoundKey = payload;
		},
		actualRound: function actualRound(state, payload) {
			state.actualRound = payload;
		},
		lastFiveRounds: function lastFiveRounds(state, payload) {
			state.lastFiveRounds = payload;
		},
		searchRounds: function searchRounds(state, payload) {
			state.searchRounds = payload;
		}
		// End Mutations

	},

	actions: {
		login: function login(_ref) {
			var commit = _ref.commit;

			commit('setLoading', true);
			commit('clearError');
			var provider = new __WEBPACK_IMPORTED_MODULE_2_firebase__["auth"].GoogleAuthProvider();
			__WEBPACK_IMPORTED_MODULE_2_firebase__["auth"]().signInWithPopup(provider).then(function (user) {
				commit('setLoading', false);
				var newUser = user.user;
				commit('setUser', newUser);
			}).catch(function (error) {
				commit('setLoading', false);
				commit('setError', error);
				console.log(error);
			});
		},
		logout: function logout(_ref2) {
			var commit = _ref2.commit;

			__WEBPACK_IMPORTED_MODULE_2_firebase__["auth"]().signOut();
			commit('setUser', null);
			commit('myHcp', null);
		},
		autoSignIn: function autoSignIn(_ref3, payload) {
			var commit = _ref3.commit;

			commit('setUser', payload);
		},
		setActualYear: function setActualYear(_ref4) {
			var commit = _ref4.commit;

			var newDate = new Date();
			var options = { year: 'numeric' };
			var actualYear = newDate.toLocaleDateString('de-DE', options);
			commit('setYear', actualYear);
		},
		setHcp: function setHcp(_ref5, payload) {
			var commit = _ref5.commit;

			var uid = this.state.user.uid;
			var name = this.state.user.displayName;
			__WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('users/' + uid).set({ name: name, hcp: payload });
		},
		fetchHcp: function fetchHcp(_ref6, payload) {
			var commit = _ref6.commit;

			var uid = payload.uid;
			__WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('users/' + uid + '/hcp').on('value', function (snapshot) {
				console.log('snapshot ' + snapshot.val());
				var tempHcp = snapshot.val();
				if (tempHcp !== null) {
					commit('myHcp', tempHcp);
				} else {
					console.log('error hcp');
				}
			});
		},
		newRoundYellow: function newRoundYellow(_ref7) {
			var commit = _ref7.commit;

			if (this.state.user) {
				// Datum erzeugen
				var newDate = new Date();
				var options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' };
				var date = newDate.toLocaleDateString('de-DE', options);

				// Keys für Round und Shortround erzeugen
				var newRoundKey = __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('users/' + this.state.user.uid + '/' + this.state.year + '/rounds').push().key;
				var newShortKey = __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('users/' + this.state.user.uid + '/' + this.state.year + '/shortrounds').push().key;

				// In Database schreiben
				__WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('users/' + this.state.user.uid + '/' + this.state.year + '/shortrounds').child(newShortKey).set({
					roundKey: newRoundKey,
					datum: date,
					farbe: "gelb",
					score: 0,
					points: 0
				});
				__WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('users/' + this.state.user.uid + '/' + this.state.year + '/rounds').child(newRoundKey).set({
					shortKey: newShortKey,
					datum: date,
					farbe: "gelb",
					hcp: this.state.myHcp,
					score1: 0,
					score2: 0,
					score3: 0,
					score4: 0,
					score5: 0,
					score6: 0,
					score7: 0,
					score8: 0,
					score9: 0,
					score10: 0,
					score11: 0,
					score12: 0,
					score13: 0,
					score14: 0,
					score15: 0,
					score16: 0,
					score17: 0,
					score18: 0
				});
			};
		},
		loadActualRoundKey: function loadActualRoundKey(_ref8) {
			var commit = _ref8.commit;

			var ref = __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('users/' + this.state.user.uid + '/' + this.state.year + '/rounds');
			ref.limitToLast(1).once('value', function (snapshot) {
				snapshot.forEach(function (childSnapshot) {
					commit('actualRoundKey', childSnapshot.key);
					store.dispatch('loadActualRound');
				});
			});
		},
		loadActualRound: function loadActualRound(_ref9) {
			var commit = _ref9.commit;

			commit('setLoading', true);
			var key = this.state.actualRoundKey;
			var ref = __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('users/' + this.state.user.uid + '/' + this.state.year + '/rounds').child(key);
			ref.on('value', function (snapshot) {
				commit('actualRound', snapshot);
			});
			commit('setLoading', false);
		},
		editScore: function editScore(_ref10, payload) {
			var commit = _ref10.commit;

			var ref = __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('users/' + this.state.user.uid + '/' + this.state.year + '/rounds').child(payload.key);
			var updates = {};
			var scoreKey = payload.loch;
			updates[scoreKey] = payload.score;
			ref.update(updates);
		},
		updateShortround: function updateShortround(_ref11, payload) {
			var commit = _ref11.commit;

			var shortRef = __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('users/' + this.state.user.uid + '/' + this.state.year + '/shortrounds').child(payload.shortKey);
			shortRef.update({ score: payload.score, points: payload.points });
		},
		getLastRounds: function getLastRounds(_ref12) {
			var commit = _ref12.commit;

			var lastFiveRounds = [];
			var ref = __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('users/' + this.state.user.uid + '/' + this.state.year + '/shortrounds');
			ref.limitToLast(5).once('value', function (snapshot) {
				snapshot.forEach(function (childSnapshot) {
					lastFiveRounds.push(childSnapshot);
				});
				commit('lastFiveRounds', lastFiveRounds);
			});
		},
		setRound: function setRound(_ref13, payload) {
			var commit = _ref13.commit;

			commit('actualRoundKey', payload.roundKey);
			store.dispatch('loadActualRound');
		},
		searchRounds: function searchRounds(_ref14, payload) {
			var commit = _ref14.commit;

			commit('setLoading', true);
			var loadedRounds = [];
			commit('searchRounds', loadedRounds);
			var ref = __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('users/' + this.state.user.uid + '/' + payload.year + '/shortrounds');
			ref.once('value', function (snapshot) {
				snapshot.forEach(function (childSnapshot) {
					loadedRounds.push(childSnapshot);
				});
				commit('searchRounds', loadedRounds);
				commit('setLoading', false);
			});
		},
		deleteRounds: function deleteRounds(_ref15, payload) {
			var commit = _ref15.commit;

			__WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('users/' + this.state.user.uid + '/' + payload.year + '/shortrounds').child(payload.shortKey).remove();
			__WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('users/' + this.state.user.uid + '/' + payload.year + '/rounds').child(payload.roundKey).remove();
			// var year = {year: payload.year}
			// store.dispatch('searchRounds', year)
		},
		deleteSearchRounds: function deleteSearchRounds(_ref16) {
			var commit = _ref16.commit;

			var rounds = [];
			commit('searchRounds', rounds);
		}

		// End Actions

	},

	getters: {
		user: function user(state) {
			return state.user;
		},
		year: function year(state) {
			return state.year;
		},
		loading: function loading(state) {
			return state.loading;
		},
		error: function error(state) {
			return state.error;
		},
		myHcp: function myHcp(state) {
			return state.myHcp;
		},
		actualRoundKey: function actualRoundKey(state) {
			return state.actualRoundKey;
		},
		actualRound: function actualRound(state) {
			return state.actualRound;
		},
		lastFiveRounds: function lastFiveRounds(state) {
			return state.lastFiveRounds;
		},
		searchRounds: function searchRounds(state) {
			return state.searchRounds;
		}
	}
});

/***/ }),

/***/ "Lhs7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LetzteRunden',

  data: function data() {
    return {};
    // End Data
  },


  computed: {
    user: function user() {
      return this.$store.getters.user;
    },
    lastFiveRounds: function lastFiveRounds() {
      return this.$store.getters.lastFiveRounds;
    },
    loading: function loading() {
      return this.$store.getters.loading;
    }
    // End Computed

  },

  methods: {
    setRound: function setRound(e) {
      if (e.currentTarget.id != null) {
        this.$store.dispatch('setRound', { roundKey: e.currentTarget.id });
        this.$router.push('/');
      }
    }
    // End Methods

  }
});

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d1cbc96_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("4vlF");
function injectStyle (ssrContext) {
  __webpack_require__("vXxx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d1cbc96_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__("3EgV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase__ = __webpack_require__("q6Ae");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuefire__ = __webpack_require__("1mcD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuefire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuefire__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "7zck"));




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vuefire___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* store */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] },

  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_5_firebase__["initializeApp"]({
      apiKey: "AIzaSyCiRdT_DwzNINrj2VvsMm07YPN1wVIXABk",
      authDomain: "mygolfappvuejs.firebaseapp.com",
      databaseURL: "https://mygolfappvuejs.firebaseio.com",
      projectId: "mygolfappvuejs",
      storageBucket: "",
      messagingSenderId: "1095500639511"
    }), this.$store.dispatch('setActualYear'), __WEBPACK_IMPORTED_MODULE_5_firebase__["auth"]().onAuthStateChanged(function (user) {
      if (user) {
        _this.$store.dispatch('autoSignIn', user);
        _this.$store.dispatch('fetchHcp', user);
        _this.$store.dispatch('loadActualRoundKey');
      }
    });
  }
});

/***/ }),

/***/ "PHEp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PO6y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SucheRunde',

  data: function data() {
    return {
      selectedYear: null,
      dialog: false,
      roundKey: null,
      shortKey: null,
      index: null
      // End Data
    };
  },


  computed: {
    user: function user() {
      return this.$store.getters.user;
    },
    year: function year() {
      return Number(this.$store.getters.year);
    },
    years: function years() {
      if (this.year != null) {
        var years = [];
        years.push(this.year, this.year - 1, this.year - 2);
        return years;
      }
    },
    searchRounds: function searchRounds() {
      return this.$store.getters.searchRounds;
    },
    loading: function loading() {
      return this.$store.getters.loading;
    }

    // End Computed

  },
  beforeDestroy: function beforeDestroy() {
    this.$store.dispatch('deleteSearchRounds');
  },


  methods: {
    setYear: function setYear() {
      this.$store.dispatch('searchRounds', { year: this.selectedYear });
    },
    openDialog: function openDialog(x, y, index) {
      this.dialog = true;
      this.roundKey = x;
      this.shortKey = y;
      this.index = index;
    },
    deleteRound: function deleteRound() {
      var z = this.selectedYear;
      this.$store.dispatch('deleteRounds', { roundKey: this.roundKey, shortKey: this.shortKey, year: z });
      this.searchRounds.splice(this.index, 1);
      this.dialog = false;
    }
    // End Methods

  }
});

/***/ }),

/***/ "UmBv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LetzteRunden_vue__ = __webpack_require__("Lhs7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b9954d42_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_LetzteRunden_vue__ = __webpack_require__("qmTB");
function injectStyle (ssrContext) {
  __webpack_require__("CB0t")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b9954d42"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LetzteRunden_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b9954d42_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_LetzteRunden_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "V6uF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SucheRunde_vue__ = __webpack_require__("PO6y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53b87e5b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SucheRunde_vue__ = __webpack_require__("tdFf");
function injectStyle (ssrContext) {
  __webpack_require__("PHEp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-53b87e5b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SucheRunde_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53b87e5b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_SucheRunde_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AktuelleRunde__ = __webpack_require__("hO3j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_LetzteRunden__ = __webpack_require__("UmBv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_SucheRunde__ = __webpack_require__("V6uF");






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'AktuelleRunde',
    component: __WEBPACK_IMPORTED_MODULE_2__components_AktuelleRunde__["a" /* default */]
  }, {
    path: '/LetzteRunden',
    name: 'LetzteRunden',
    component: __WEBPACK_IMPORTED_MODULE_3__components_LetzteRunden__["a" /* default */]
  }, {
    path: '/SucheRunde',
    name: 'SucheRunde',
    component: __WEBPACK_IMPORTED_MODULE_4__components_SucheRunde__["a" /* default */]
  }]
}));

/***/ }),

/***/ "hO3j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AktuelleRunde_vue__ = __webpack_require__("6He6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8112d9b8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_AktuelleRunde_vue__ = __webpack_require__("wxf1");
function injectStyle (ssrContext) {
  __webpack_require__("ATWO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8112d9b8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AktuelleRunde_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8112d9b8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_AktuelleRunde_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qmTB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.lastFiveRounds != null && _vm.user)?_c('div',{staticClass:"LetzteRunden"},[_c('h3',[_vm._v("Letzte 5 Runden")]),_vm._v(" "),_c('v-layout',[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":""}},[(_vm.loading)?_c('v-progress-circular',{staticClass:"warning--text",attrs:{"indeterminate":"","width":7,"size":70}}):_vm._e()],1)],1),_vm._v(" "),(!_vm.loading)?_c('v-layout',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-card-title',{staticClass:"pt-2 pb-0",attrs:{"primary-title":""}},[_c('h4',{staticClass:"mb-1"},[_vm._v("Bitte Runde auswählen")])]),_vm._v(" "),_c('v-card-text',{staticClass:"pt-0"},[_c('table',[_c('thead',[_c('tr',[_c('th',{staticStyle:{"width":"40%"}},[_vm._v("Datum")]),_vm._v(" "),_c('th',{staticClass:"tableData"},[_vm._v("Kurs")]),_vm._v(" "),_c('th',{staticClass:"tableData"},[_vm._v("Punkte")]),_vm._v(" "),_c('th',{staticClass:"tableData"},[_vm._v("Schläge")])])]),_vm._v(" "),_vm._l((_vm.lastFiveRounds),function(round){return _c('tbody',{key:round.val().roundKey},[_c('tr',{staticClass:"editRow",attrs:{"id":round.val().roundKey},on:{"click":function($event){$event.stopPropagation();_vm.setRound($event)}}},[_c('td',[_vm._v(_vm._s(round.val().datum))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(round.val().farbe))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(round.val().points))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(round.val().score))])])])})],2)])],1)],1)],1):_vm._e()],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tdFf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user)?_c('div',{staticClass:"SucheRunde",attrs:{"slot":"activator"},slot:"activator"},[_c('h3',[_vm._v("Suche Runde")]),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"xs12":""}},[(_vm.year != null)?_c('v-card',[_c('v-card-title',{staticClass:"pt-2 pb-0",attrs:{"primary-title":""}},[_c('h4',{staticClass:"mb-1"},[_vm._v("Bitte Jahr auswählen")])]),_vm._v(" "),_c('v-card-text',{staticClass:"pt-0 pb-0"},[_c('v-select',{attrs:{"items":_vm.years,"label":"Jahr auswählen","single-line":"","bottom":""},model:{value:(_vm.selectedYear),callback:function ($$v) {_vm.selectedYear=$$v},expression:"selectedYear"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"blue--text darken-1",attrs:{"flat":"flat"},nativeOn:{"click":function($event){_vm.setYear($event)}}},[_vm._v("Auswählen")])],1)],1):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":""}},[(_vm.loading)?_c('v-progress-circular',{staticClass:"warning--text",attrs:{"indeterminate":"","width":7,"size":70}}):_vm._e()],1)],1),_vm._v(" "),(_vm.searchRounds != null && !_vm.loading)?_c('v-card',[_c('v-card-title',{staticClass:"pb-0",attrs:{"primary-title":""}},[_c('h4',{staticClass:"mb-1"},[_vm._v("Zum Löschen antippen")])]),_vm._v(" "),_c('table',[_c('thead',[_c('tr',[_c('th',{staticStyle:{"width":"40%"}},[_vm._v("Datum")]),_vm._v(" "),_c('th',{staticClass:"tableData"},[_vm._v("Kurs")]),_vm._v(" "),_c('th',{staticClass:"tableData"},[_vm._v("Punkte")]),_vm._v(" "),_c('th',{staticClass:"tableData"},[_vm._v("Schläge")])])]),_vm._v(" "),_vm._l((_vm.searchRounds),function(round,index){return _c('tbody',{key:index},[_c('tr',{staticClass:"editRow",on:{"click":function($event){$event.stopPropagation();_vm.openDialog(round.val().roundKey, round.key, index)}}},[_c('td',[_vm._v(_vm._s(round.val().datum))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(round.val().farbe))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(round.val().points))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(round.val().score))])])])})],2)],1):_vm._e()],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"lazy":"","absolute":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',[_c('div',{staticClass:"headline"},[_vm._v("Runde löschen?")])]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"red--text darken-1",attrs:{"flat":"flat"},nativeOn:{"click":function($event){_vm.dialog = false}}},[_vm._v("Abbrechen")]),_vm._v(" "),_c('v-btn',{staticClass:"blue--text darken-1",attrs:{"flat":"flat"},nativeOn:{"click":function($event){_vm.deleteRound($event)}}},[_vm._v("Löschen")])],1)],1)],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vXxx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wxf1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.round != null && _vm.user)?_c('div',{staticClass:"AktuelleRunde"},[_c('h3',[_vm._v("Aktuelle Runde")]),_vm._v(" "),_c('v-layout',[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":""}},[(_vm.loading)?_c('v-progress-circular',{staticClass:"warning--text",attrs:{"indeterminate":"","width":7,"size":70}}):_vm._e()],1)],1),_vm._v(" "),(!_vm.loading)?_c('v-layout',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-card-title',{staticClass:"pt-2 pb-0",attrs:{"primary-title":""}},[_c('h4',{staticClass:"mb-1"},[_vm._v(_vm._s(_vm.round.val().datum))])]),_vm._v(" "),_c('v-card-text',{staticClass:"pt-0"},[_c('h5',{staticClass:"mb-1"},[_vm._v("Hcp "+_vm._s(_vm.myHcp)+" | "+_vm._s(_vm.round.val().farbe))]),_vm._v(" "),_c('table',{attrs:{"id":"scoreTable"}},[_c('thead',[_c('tr',[_c('th',[_vm._v("Loch-Nr")]),_vm._v(" "),_c('th',[_vm._v("Par")]),_vm._v(" "),_c('th',[_vm._v("Vorgabe")]),_vm._v(" "),_c('th',[_vm._v("Punkte")]),_vm._v(" "),_c('th',[_vm._v("Schläge")])])]),_vm._v(" "),_c('tbody',[_c('tr',{on:{"click":function($event){$event.stopPropagation();_vm.dialog = true, _vm.hole = 1}}},[_c('td',[_vm._v("1")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.myColorArray[0]))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.myStablefordYellowSign[0]))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.pointsOut[0]))]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.round.val().score1))])])]),_vm._v(" "),_c('tr',{on:{"click":function($event){$event.stopPropagation();_vm.dialog = true, _vm.hole = 2}}},[_c('td',[_vm._v("2")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.myColorArray[1]))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.myStablefordYellowSign[1]))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.pointsOut[1]))]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.round.val().score2))])])]),_vm._v(" "),_c('tr',{on:{"click":function($event){$event.stopPropagation();_vm.dialog = true, _vm.hole = 3}}},[_c('td',[_vm._v("3")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.myColorArray[2]))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.myStablefordYellowSign[2]))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.pointsOut[2]))]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.round.val().score3))])])]),_vm._v(" "),_c('tr',{on:{"click":function($event){$event.stopPropagation();_vm.dialog = true, _vm.hole = 4}}},[_c('td',[_vm._v("4")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.myColorArray[3]))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.myStablefordYellowSign[3]))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.pointsOut[3]))]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.round.val().score4))])])]),_vm._v(" "),_c('tr',{on:{"click":function($event){$event.stopPropagation();_vm.dialog = true, _vm.hole = 5}}},[_c('td',[_vm._v("5")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.myColorArray[4]))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.myStablefordYellowSign[4]))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.pointsOut[4]))]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.round.val().score5))])])]),_vm._v(" "),_c('tr',{on:{"click":function($event){$event.stopPropagation();_vm.dialog = true, _vm.hole = 6}}},[_c('td',[_vm._v("6")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.myColorArray[5]))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.myStablefordYellowSign[5]))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.pointsOut[5]))]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.round.val().score6))])])]),_vm._v(" "),_c('tr',{on:{"click":function($event){$event.stopPropagation();_vm.dialog = true, _vm.hole = 7}}},[_c('td',[_vm._v("7")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.myColorArray[6]))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.myStablefordYellowSign[6]))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.pointsOut[6]))]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.round.val().score7))])])]),_vm._v(" "),_c('tr',{on:{"click":function($event){$event.stopPropagation();_vm.dialog = true, _vm.hole = 8}}},[_c('td',[_vm._v("8")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.myColorArray[7]))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.myStablefordYellowSign[7]))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.pointsOut[7]))]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.round.val().score8))])])]),_vm._v(" "),_c('tr',{on:{"click":function($event){$event.stopPropagation();_vm.dialog = true, _vm.hole = 9}}},[_c('td',[_vm._v("9")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.myColorArray[8]))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.myStablefordYellowSign[8]))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.pointsOut[8]))]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.round.val().score9))])])]),_vm._v(" "),_c('tr',{staticStyle:{"height":"4em"}},[_c('td',[_c('strong',[_vm._v("Score Out")])]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(_vm.sumPointsOut))])]),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(_vm.scoreOut))])])]),_vm._v(" "),_c('tr',{on:{"click":function($event){$event.stopPropagation();_vm.dialog = true, _vm.hole = 10}}},[_c('td',[_vm._v("10")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.myColorArray[9]))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.myStablefordYellowSign[9]))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.pointsOut[9]))]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.round.val().score10))])])]),_vm._v(" "),_c('tr',{on:{"click":function($event){$event.stopPropagation();_vm.dialog = true, _vm.hole = 11}}},[_c('td',[_vm._v("11")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.myColorArray[10]))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.myStablefordYellowSign[10]))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.pointsOut[10]))]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.round.val().score11))])])]),_vm._v(" "),_c('tr',{on:{"click":function($event){$event.stopPropagation();_vm.dialog = true, _vm.hole = 12}}},[_c('td',[_vm._v("12")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.myColorArray[11]))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.myStablefordYellowSign[11]))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.pointsOut[11]))]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.round.val().score12))])])]),_vm._v(" "),_c('tr',{on:{"click":function($event){$event.stopPropagation();_vm.dialog = true, _vm.hole = 13}}},[_c('td',[_vm._v("13")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.myColorArray[12]))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.myStablefordYellowSign[12]))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.pointsOut[12]))]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.round.val().score13))])])]),_vm._v(" "),_c('tr',{on:{"click":function($event){$event.stopPropagation();_vm.dialog = true, _vm.hole = 14}}},[_c('td',[_vm._v("14")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.myColorArray[13]))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.myStablefordYellowSign[13]))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.pointsOut[13]))]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.round.val().score14))])])]),_vm._v(" "),_c('tr',{on:{"click":function($event){$event.stopPropagation();_vm.dialog = true, _vm.hole = 15}}},[_c('td',[_vm._v("15")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.myColorArray[14]))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.myStablefordYellowSign[14]))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.pointsOut[14]))]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.round.val().score15))])])]),_vm._v(" "),_c('tr',{on:{"click":function($event){$event.stopPropagation();_vm.dialog = true, _vm.hole = 16}}},[_c('td',[_vm._v("16")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.myColorArray[15]))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.myStablefordYellowSign[15]))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.pointsOut[15]))]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.round.val().score16))])])]),_vm._v(" "),_c('tr',{on:{"click":function($event){$event.stopPropagation();_vm.dialog = true, _vm.hole = 17}}},[_c('td',[_vm._v("17")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.myColorArray[16]))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.myStablefordYellowSign[16]))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.pointsOut[16]))]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.round.val().score17))])])]),_vm._v(" "),_c('tr',{on:{"click":function($event){$event.stopPropagation();_vm.dialog = true, _vm.hole = 18}}},[_c('td',[_vm._v("18")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.myColorArray[17]))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.myStablefordYellowSign[17]))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.pointsOut[17]))]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.round.val().score18))])])]),_vm._v(" "),_c('tr',{staticStyle:{"height":"4em"}},[_c('td',[_c('strong',[_vm._v("Score In")])]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(_vm.sumPointsIn))])]),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(_vm.scoreIn))])])])]),_vm._v(" "),_c('tfoot',[_c('tr',{staticStyle:{"border-top":"1px solid black"}},[_c('th',[_vm._v("Gesamtscore")]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.points))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.score))])])])])])],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-dialog',{attrs:{"lazy":"","absolute":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',[_c('div',{staticClass:"headline"},[_vm._v("Ergebnis Loch "+_vm._s(_vm.hole))])]),_vm._v(" "),_c('v-card-text',[_vm._v("\n        Gewählter Score: "),_c('strong',[_vm._v(_vm._s(_vm.number))]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_vm._l((_vm.options),function(i){return _c('v-flex',{key:i,attrs:{"xs4":""}},[_c('v-btn',{staticClass:"mt-6 mr-0 ml-0 mb-6",attrs:{"light":"","offset-xs1":""},on:{"click":function($event){_vm.number = i}},model:{value:(_vm.number),callback:function ($$v) {_vm.number=$$v},expression:"number"}},[_vm._v(_vm._s(i))])],1)}),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","offset-xs4":""}},[_c('v-btn',{staticClass:"mt-6 mr-0 ml-0 mb-0",attrs:{"light":""},on:{"click":function($event){_vm.number = '0'}},model:{value:(_vm.number),callback:function ($$v) {_vm.number=$$v},expression:"number"}},[_vm._v("0")])],1)],2)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"red--text darken-1",attrs:{"flat":"flat"},nativeOn:{"click":function($event){_vm.dialog = false, _vm.hole = null}}},[_vm._v("Abbrechen")]),_vm._v(" "),_c('v-btn',{staticClass:"blue--text darken-1",attrs:{"flat":"flat"},nativeOn:{"click":function($event){_vm.setScore($event)}}},[_vm._v("Speichern")])],1)],1)],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',

  data: function data() {
    return {
      drawer: true,
      dialog: false,
      number: null
      // End Data
    };
  },


  // watch: {

  // },

  computed: {
    user: function user() {
      return this.$store.getters.user;
    },
    myHcp: function myHcp() {
      return this.$store.getters.myHcp;
    },
    lastFiveRounds: function lastFiveRounds() {
      return this.$store.getters.lastFiveRounds;
    }
    // End Computed

  },

  methods: {
    x: function x() {},
    login: function login() {
      this.$store.dispatch('login');
    },
    logout: function logout() {
      this.$store.dispatch('logout');
    },
    getActualRound: function getActualRound() {
      this.$store.dispatch('loadActualRoundKey');
      var size = window.innerWidth;
      if (size < 960) {
        this.drawer = false;
      }
    },
    getLastRounds: function getLastRounds() {
      this.$store.dispatch('getLastRounds');
      var size = window.innerWidth;
      if (size < 960) {
        this.drawer = false;
      }
    },
    openDialog: function openDialog() {
      this.dialog = true;
      var size = window.innerWidth;
      if (size < 960) {
        this.drawer = false;
      }
    },
    setHcp: function setHcp() {
      this.$store.dispatch('setHcp', this.number);
      this.number = null;
      this.dialog = false;
    },
    newRoundYellow: function newRoundYellow() {
      this.$store.dispatch('newRoundYellow');
      this.$store.dispatch('loadActualRoundKey');
      var size = window.innerWidth;
      if (size < 960) {
        this.drawer = false;
      }
    }
    // End Methods

  }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.bf098d21ef9f60c23474.js